import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { NftRoutingModule } from './nft-routing.module';
import { NftComponent } from './nft.component';
// import { CoreModule } from '@angular/flex-layout';
import { CoreModule } from 'src/app/core/core.module';
import { DirectivesModule } from 'src/app/core/directives/directives.module';
import { NftCollectionsComponent } from './nft-collections/nft-collections.component';
import { NftProductsComponent } from './nft-products/nft-products.component';
import { NftProductOverviewComponent, nftResponse } from './nft-product-overview/nft-product-overview.component';
import { InfiniteScrollModule } from 'ngx-infinite-scroll';

@NgModule({
  declarations: [NftComponent, NftCollectionsComponent, NftProductsComponent, NftProductOverviewComponent, nftResponse],
  imports: [
    CommonModule,
    NftRoutingModule,
    CoreModule,
    DirectivesModule,
    InfiniteScrollModule
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class NftModule { }
